import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import logoDark from "@/assets/brand/logo-full-dark.png";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role !== "admin") {
        toast.error("Access restricted");
        return;
      }
      toast.success(`Welcome, ${u.name.split(" ")[0]}`);
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="login-page" className="min-h-[80vh] grid place-items-center px-6 py-16">
      <div className="w-full max-w-md">
        <img
          src={logoDark}
          alt="Dreamy Interiors"
          className="h-16 w-auto mb-10 select-none"
          draggable="false"
        />
        <p className="overline">Team access</p>
        <h1 className="font-heading text-4xl mt-3">Admin sign in</h1>
        <p className="text-sm text-[#5C5C5C] mt-2">Private access for the Dreamy Interiors team.</p>

        <form onSubmit={submit} className="mt-10 space-y-6">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#5C5C5C]">Email</label>
            <input data-testid="login-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-line mt-2" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#5C5C5C]">Password</label>
            <input data-testid="login-password" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="input-line mt-2" />
          </div>
          <button data-testid="login-submit" disabled={loading} className="btn-primary w-full">{loading ? "Signing in…" : "Sign in"}</button>
        </form>
      </div>
    </div>
  );
}
